module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAAAAXNSR0IArs4c6QAAANtJREFUSEvtlcENgkAQRWdEyrABQTEkxKNnTLAMY0uU4QXv3owJaBQL0DIEvsFoImaVIYjx4J7/vv37Z2eW6UOLTXu8qcsCE9iwXdQFETUGamsDqTsdGZ9TRDd98WpxuGApKNc9xKIG9RxvhCzrqqDcQrxbB0sRyLBdn4imShCxvw+D2XdBluMZoLSjcqS19GO0mh9EjqSBl4b9B5U/yH9GrzNi4q00n1wHgqUcI1UgT9riGGGmUxUYQPd+bHiwSV0137S/VzVpNgod2BxO+jUA162cJKj0j7078AI65rkVcHd9KQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_mobile.png
// module id = U/vy
// module chunks = 1